import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { LayoutUtilsService } from "src/app/core/services/layout-utils.service";
import { LoaderService } from "src/app/core/services/loader.service";
import { RequestService } from "src/app/core/services/request.service";
import { ConfirmDialogComponent } from "src/app/shared/confirm-dialog/confirm-dialog.component";
import { CharactersComponent } from "src/app/shared/modals/characters/characters.component";

export interface CharacterListTable {
    id: string;
    name: string;
    gender: string;
}

@Component({
    selector: 'app-characters-list',
    templateUrl: './characters-list.component.html',
    styleUrls: ['./characters-list.component.scss']
})

export class CharactersListComopnent implements OnInit {
    @ViewChild(MatPaginator) paginator!: MatPaginator;

    displayedColumns: string[] = ['pictureLink', 'name', 'gender', 'age', 'tools'];
    datasource: any = undefined;
    public defaultPictureLink: string = 'assets/images/profile.png';

    constructor(private requestService: RequestService, private translate: TranslateService, private layoutUtilsService: LayoutUtilsService, private loadService: LoaderService, private router: Router, private dialog: MatDialog) {
    }

    ngOnInit() {
        this.getCharacters();
    }

    getCharacters() {
        this.loadService.display(true);
        this.requestService.getDataListByOrgByGet('character', (data, error) => {
            if (error) {
                this.layoutUtilsService.showNotification(this.translate.instant('Error:') + error, this.translate.instant('Dismiss'));
            }
            if (data) {
                // console.log('opening acts', data.results)
                this.datasource = new MatTableDataSource<CharacterListTable>(data.results);
                this.datasource.paginator = this.paginator;
            }
            this.loadService.display(false);
        });
    }

    deleteCharacter(id: string) {
        const dialog = this.dialog.open(ConfirmDialogComponent, {
            data: {
                message: this.translate.instant('Are you sure you want to delete this character?'),
                title: ''
            }, width: 'fit-content'
        });
        dialog.afterClosed().subscribe(result => {
            if (result) {
                this.loadService.display(true);
                this.requestService.deleteData('character', id, (data, error) => {
                    if (data) {
                        this.layoutUtilsService.showNotification(this.translate.instant('Deleted Successfully'), this.translate.instant('Dismiss'));
                        this.getCharacters();
                    }
                    else if (error) {
                        this.layoutUtilsService.showNotification(this.translate.instant('Error:') + error, this.translate.instant('Dismiss'));
                    }
                    this.loadService.display(false);
                });
            }
        });
    }

    addCharacter() {
        const dialog = this.dialog.open(CharactersComponent, {
            disableClose: true,
            autoFocus: true,
            width: '60vw',
            data: {
                title: 'Create a Character'
            }
        });
        dialog.afterClosed().subscribe((result: any) => {
            if (result) {
                if (result.redirectTo) {
                    this.router.navigate([result.redirectTo]);
                    this.getCharacters();
                }
            }
        });
    }

    editCharacter(id: string) {
        const dialog = this.dialog.open(CharactersComponent, {
            disableClose: true,
            autoFocus: true,
            width: '60vw',
            data: {
                title: 'Edit Character',
                id: id
            }
        });
        dialog.afterClosed().subscribe((result: any) => {
            if (result) {
                if (result.redirectTo) {
                    this.router.navigate([result.redirectTo]);
                    this.getCharacters();
                }
            }
        });
    }
}